import React from 'react';
import { CardWrapper } from '../assets/style';
import { CheckBox } from 'components/CheckBox';


/**
 * @description
 * address card component which renders individual address elements
 * @param AddressCardProps
 * @returns - card component
 */
export const ImportAddressCard = ({
  tag,
  isChecked,
  address,
  handleCheckBoxClick,
}: AddressCardProps) => {
  const {
    firstName,
    city,
    postcode,
    region,
    street,
    phone,
  } = address;

  return (
    <CardWrapper data-testId="import-address-card"  onClick={(event: React.MouseEvent) => handleCheckBoxClick(address, event)}>
      <div className="layout vertical">
        <div className="layout horizontal center mb4">
          <p className="font-medium" style={ { color: 'rgba(0,19,37,0.92)' } }>{firstName}</p>
          {
            tag && (
              <div className="label">
                {tag}
              </div>
            )
          }
          <CheckBox
            isChecked={isChecked}
            borderRadius={8}
            dataTestId={"import-checkbox"}
          />
        </div>
      </div>
      <div className="layout vertical address" data-testid="txt_address_bar">
        {street}
        <p className="font-medium">{city}-{postcode}</p>
        <div className="layout horizontal">
          <p className="font-medium">{phone}</p>
        </div>
      </div>
    </CardWrapper>
  );
};
